// Component: KillSwitchControl.jsx
// Purpose: #133 — compact kill-switch control for page headers (strategy deep-dive). Renders
//          NOTHING while trading is enabled; red chip + "Resume trading…" only when the
//          user-scope kill-switch is ACTIVE (amber chip if the state read itself fails). The resume flow itself lives in ResumeTradingModal (shared with the banner).

import React, { useState } from 'react';
import { useOwnKillSwitch } from '../../hooks/trading/useOwnKillSwitch';
import ResumeTradingModal from './ResumeTradingModal';

export default function KillSwitchControl() {
  /*>>> State <<<*/
  const { state, active, trip, degraded, readError, busy, error, setError, resume } = useOwnKillSwitch();
  const [open, setOpen] = useState(false);

  if (degraded && !state) {
    //! the read never succeeded: say so and say why — never render "off" for "unknown".
    return (
      <span
        data-testid="kill-switch-control"
        title={readError || 'State read failed'}
        className="text-xs px-2 py-1 rounded"
        style={{ background: '#78350f', color: '#fff', border: '1px solid #fbbf24', maxWidth: 420, whiteSpace: 'normal' }}
      >
        Kill-switch: read failed — {readError || 'unknown'}
      </span>
    );
  }

  //! Deepak 2026-08-28: when things are good, show NOTHING — a permanent "kill-switch: off" chip
  //! only confuses the user. The control exists only while the switch is ACTIVE (or the read
  //! itself is failing, which is a real problem worth a small amber chip).
  if (!state || !active) return null;

  return (
    <>
      <span
        data-testid="kill-switch-control"
        className="text-xs px-2 py-1 rounded"
        style={{ background: '#7f1d1d', color: '#fff', border: '1px solid #fca5a5' }}
        title={trip ? `Tripped ${fmtIst(trip.timestamp)} — ${trip.reason}` : 'Trip details unavailable'}
      >
        ⛔ Trading halted (kill-switch)
      </span>
      <button type="button" className="btn btn-danger" onClick={() => setOpen(true)}>
        Resume trading…
      </button>
      <ResumeTradingModal
        open={open}
        onClose={() => setOpen(false)}
        trip={trip}
        busy={busy}
        error={error}
        setError={setError}
        resume={resume}
      />
    </>
  );
}

const fmtIst = (iso) => {
  try { return new Date(iso).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', hour12: false }); } catch { return iso; }
};
